/**
 * SceltiStructures — sezione homepage "Scelto da Vita da Host".
 * Replica 1:1 del riferimento (vedi scelti.css): pannello sinistro fisso,
 * nastro card in scorrimento automatico con loop infinito, card candidatura
 * in coda, fascia blur sotto il logo. Usa i dati reali delle strutture "Scelto".
 */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./scelti.css";

const API = `${window.__BACKEND__}/api`;
const CANDIDATI = "/servizi/scelto-da-vita-da-host#candidati";
const MAPPA = "/servizi/scelto-da-vita-da-host#mappa";
const LOGO = "/scelto-badge-logo.jpg";

function StructureCard({ s, hidden }) {
  const meta = [s.citta, s.regione].filter(Boolean).join(" · ");
  return (
    <Link
      className="vdh-card"
      to={`/scelto/${encodeURIComponent(s.id)}`}
      aria-hidden={hidden ? "true" : undefined}
      tabIndex={hidden ? -1 : undefined}
      data-testid={hidden ? undefined : `scelti-card-${s.id}`}
    >
      <div className="vdh-card__img">
        <img src={s.foto_copertina} alt={s.titolo || "Struttura"} width="260" height="150" loading="lazy" />
        <span className="vdh-badge">Scelto</span>
      </div>
      <div className="vdh-card__body">
        <span className="vdh-card__name vdh-ell">{s.titolo}</span>
        {meta && <span className="vdh-card__meta vdh-ell">{meta}</span>}
        {s.nome_host && <span className="vdh-card__meta vdh-ell">Host: {s.nome_host}</span>}
      </div>
    </Link>
  );
}

function CtaCard({ hidden }) {
  return (
    <Link
      className="vdh-card vdh-card--cta"
      to={CANDIDATI}
      aria-hidden={hidden ? "true" : undefined}
      tabIndex={hidden ? -1 : undefined}
      data-testid={hidden ? undefined : "scelti-cta-card"}
    >
      <span className="vdh-cta__title">La tua struttura qui.</span>
      <span className="vdh-cta__text">Candidala gratis, la visitiamo e se ci convince entra nella selezione.</span>
      <span className="vdh-cta__link">Candidati gratis →</span>
    </Link>
  );
}

export default function SceltiStructures() {
  const [items, setItems] = useState([]);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    fetch(`${API}/scelto/structures`)
      .then((r) => r.json())
      .then((j) => {
        if (!mounted.current) return;
        const list = (j.items || []).filter((s) => s.enabled !== false && s.foto_copertina);
        setItems(list);
      })
      .catch(() => {});
    return () => { mounted.current = false; };
  }, []);

  // One "set" = tutte le strutture + 1 card candidatura. Il nastro duplica il set.
  const setCount = items.length + 1;
  const durStyle = useMemo(() => ({
    "--vdh-dur": `${Math.max(24, Math.round(setCount * 11.5))}s`,
    "--vdh-dur-m": `${Math.max(20, Math.round(setCount * 8.5))}s`,
  }), [setCount]);

  const renderSet = (hidden) => (
    <>
      {items.map((s) => <StructureCard key={`${hidden ? "d" : "o"}-${s.id}`} s={s} hidden={hidden} />)}
      <CtaCard hidden={hidden} />
    </>
  );

  return (
    <section className="vdh-scelti" aria-label="Strutture scelte da Vita da Host" data-testid="scelti-section">
      <div className="vdh-panel">
        <div className="vdh-head">
          <img className="vdh-logo" src={LOGO} alt="Scelto da Vita da Host" width="96" height="96" />
          <h2 className="vdh-title">Strutture extralberghiere<br /> scelte da Vita da Host</h2>
        </div>
        <p className="vdh-text">
          <strong>Testate, visitate e approvate</strong> da Vita da Host. Contatta gli host direttamente o <strong>candida la tua struttura</strong>.
        </p>
        <div className="vdh-actions">
          <Link className="vdh-btn vdh-btn--yellow" to={CANDIDATI} data-testid="scelti-candidati-btn">Candidati gratis</Link>
          <Link className="vdh-btn vdh-btn--outline" to={MAPPA} data-testid="scelti-mappa-btn">
            <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
              <circle cx="12" cy="9.5" r="2.5" />
            </svg>
            <span className="vdh-label-long">Apri la mappa</span>
            <span className="vdh-label-short">Mappa</span>
          </Link>
        </div>
      </div>
      <div className="vdh-blur" aria-hidden="true" />
      <div className="vdh-viewport">
        <div className="vdh-track" style={durStyle}>
          {renderSet(false)}
          {renderSet(true)}
        </div>
      </div>
    </section>
  );
}
